var componentRequireContext = require.context("components/Leaflets", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
